import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderError = {
    get(filters) {
        return Call(`bidder/error?${objToQs(filters)}`);
    },

    getGraph(filters) {
        return Call(`bidder/error/graph?${objToQs(filters)}`);
    },
};

export default BidderError;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderError.js